// extracted by mini-css-extract-plugin
export default {"userBox":"NotificationsContainer-userBox-a7e18a8f554fbfeadb4878d0a95b754c","title":"NotificationsContainer-title-6d4136832d068834f2aacf860706330a"};